import type { FC } from 'react';
import { ClientAvatar, Info, Name } from '@features/clients/';
import { Color } from '@features/clients/client-color';
import type { Client } from '@shared/types/users';
import { ClientTabsMobile } from '@src/features/clients/client-tabs/ui/client-tabs-mobile';
import * as st from './styles.module.scss';

type Props = {
  client: Client;
};

export const ClientMobile: FC<Props> = ({ client }) => {
  return (
    client && (
      <section className={st.section}>
        <div className={st.client}>
          {client && <Color client={client} />}
          <section className={st.client__photo}>
            {client && <ClientAvatar size="md" client={client} />}
          </section>
          <section className={st.client__data}>
            {client && <Name client={client} />}
            {client && <Info client={client} />}
          </section>
        </div>
        <ClientTabsMobile />
      </section>
    )
  );
};
